import React, { createContext, useState, useContext, useEffect } from 'react';
import websocketService from '../services/websocketService';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  
  // Load token and user from localStorage on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
      
      // Connect WebSocket with stored token
      websocketService.connect(storedToken);
    }
  }, []);
  
  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    
    // Persist to localStorage
    localStorage.setItem('authToken', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    
    // Connect WebSocket
    websocketService.connect(authToken);
  };
  
  const logout = () => {
    setUser(null);
    setToken(null);
    
    // Clear localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    // Disconnect WebSocket
    websocketService.disconnect();
  };
  
  // Helper function to get auth headers for API calls
  const getAuthHeaders = () => {
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  };
  
  return (
    <AuthContext.Provider value={{ user, token, login, logout, getAuthHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
